import RiskScoreTag from 'components/atoms/tags/riskScoreTag';
import DoNotCallTag from 'components/atoms/tags/DoNotCallTag';
import EmailUnsubscribedTag from 'components/atoms/tags/EmailUnsubscribedTag';
import SlaTag from 'components/atoms/tags/SlaTag';
import classNames from 'classnames';
import PcmTag from 'components/atoms/tags/PcmTag';
import { isCcmModule, isCombinedModule } from 'infrastructure/functions';
import { isMobile } from 'utils/deviceHelper';
import { useAppDispatch, useAppSelector } from 'store';
import ListIcon from 'components/atoms/icons/listIcon';
import { type ModuleType } from 'infrastructure/enums';
import SalesForceIntegrationTag from 'components/atoms/tags/sales-force-integration-tag';

import s from './styles.module.scss';
import MobileMiniNav from '../mini-nav/mobile-mini-nav';

import type { ReactElement, FC } from 'react';

interface PatientMiniTopBannerProps {
  fullName: string;
  riskScore?: number;
  clinicName: ReactElement | string;
  doNotCall?: boolean;
  showEmailTag: boolean;
  physician?: ReactElement | string;
  sla?: number;
  isPatient?: boolean;
  fullWight?: boolean;
  pcmStatus?: boolean;
  showSalesForceIntegration?: boolean;
  statusColor?: string;
  module: ModuleType;
}

const PatientMiniTopBanner: FC<PatientMiniTopBannerProps> = ({
  fullName,
  riskScore,
  clinicName,
  doNotCall,
  showEmailTag,
  physician,
  sla,
  isPatient,
  fullWight = false,
  pcmStatus,
  showSalesForceIntegration,
  statusColor,
  module,
}) => {
  const deviceType = useAppSelector((state) => state.user.deviceType);
  const {
    modalWindows: { toggleOpenMobileMiniNav },
  } = useAppDispatch();

  return (
    <>
      <div
        data-cy="patient-header-small"
        className={classNames(s.wrapper, { [s['full-wight']]: fullWight })}
      >
        <div
          className={s['status-indicator']}
          style={{ backgroundColor: statusColor }}
        />
        <div className={s['title-wrapper']}>
          <p data-cy="patient-name" className={s.title}>
            {fullName}
          </p>
          {!isMobile(deviceType) && !isPatient && (
            <>
              {typeof sla !== 'undefined' && <SlaTag hours={sla} small />}
              {doNotCall && <DoNotCallTag small />}
              {showEmailTag && <EmailUnsubscribedTag small />}
              {pcmStatus && <PcmTag small />}
              {showSalesForceIntegration && <SalesForceIntegrationTag small />}
            </>
          )}
        </div>
        <div className={s['info-wrapper']}>
          <p data-cy="physician-name" className={s['physician-title']}>
            {physician}
          </p>
          <p data-cy="clinic-name" className={s['clinic-title']}>
            {clinicName}
          </p>
          {typeof riskScore !== 'undefined' &&
            (isCcmModule(module) || isCombinedModule(module)) && (
              <RiskScoreTag score={riskScore} />
            )}
        </div>
        <div
          className={s['mobile-mini-vav']}
          onClick={() => toggleOpenMobileMiniNav()}
        >
          <ListIcon />
        </div>
      </div>
      <MobileMiniNav module={module} />
    </>
  );
};

export default PatientMiniTopBanner;
